import {defineStore} from "pinia";
import {ref} from "vue";
import {request as __request} from "@hubblecommerce/hubble/platforms/shopware/request";
import {OpenAPI} from "@hubblecommerce/hubble/platforms/shopware/api-client";
import {hblMapProducts} from "#imports";
import type {HblProduct, HblIUseSetProduct} from '@/utils/types'

export const useSetProduct = defineStore('use-set-product', ():HblIUseSetProduct  => {
    const setInformation: Ref<null|Record<any, any>> = ref(null)
    const configuredSet: Ref<null|Record<string, number>> = ref(null)

    const fetchSet = async function(id: string): Promise<void> {
        const response: any = await __request(OpenAPI, {
            method: 'POST',
            url: `/product/${id}/set`,
            body: {
                associations: {
                    manufacturer: {},
                }
            }
        })

        response[0].products = hblMapProducts(response?.[0]?.products)
        if (!response?.[0]?.productSet?.defined) {
            configuredSet.value = {}
            response?.[0]?.products?.forEach((product: HblProduct) => {
                configuredSet.value[product.id] = 0
            })
        } else {
            configuredSet.value = {}
            response?.[0]?.productSet?.assignedProducts?.forEach((product: Record<any, any>) => {
                configuredSet.value[product.productId] = product.count
            })
        }

        setInformation.value = response?.[0]
    }

    const resetSet = () => {
        configuredSet.value = null
        setInformation.value = null
    }

    const configuredSetPayload = computed((): null | Record<any, any>[] => {
        if (configuredSet.value === null) {
            return null
        }

        const productSet = []
        Object.entries(configuredSet.value).forEach(product => {
            const [id, count] = product
            if (count > 0) {
                productSet.push({
                    id: id,
                    quantity: count
                })
            }
        })

        return productSet
    })

    const selectedProductCount = computed((): number => {
        return Object.values(configuredSet.value).reduce(
            (acc, value) => acc + value,
            0,
        );
    })

    onUnmounted(() => {
        resetSet()
    })

    return {
        configuredSet,
        setInformation,
        selectedProductCount,
        configuredSetPayload,
        fetchSet,
        resetSet, // <-- wichtig, damit es im Store verfügbar ist
    }
})
